if (!window.App) {
  window.App = {}
}

App.$ = $ // Allows us to use App.$ in UJS partials to get the Cash wrapper.

App.refireLoad = () => document.dispatchEvent(new Event("turbolinks:load", { bubbles: true, cancelable: true }))
